export const EMITTER_SLOT_CREATURE_SMOKE = {
    alpha: {
        start: 0.8,
        end: 0,
    },
    scale: {
        start: 2,
        end: 0,
        minimumScaleMultiplier: 1,
    },
    color: {
        start: "#ffffff",
        end: "#c1c1c1",
    },
    speed: {
        start: 200,
        end: 0,
        minimumSpeedMultiplier: 1,
    },
    acceleration: {
        x: 0,
        y: 0,
    },
    maxSpeed: 0,
    startRotation: {
        min: 0,
        max: 360,
    },
    noRotation: false,
    rotationSpeed: {
        min: 50,
        max: 100,
    },
    lifetime: {
        min: 0.4,
        max: 0.6,
    },
    blendMode: "normal",
    frequency: 0.001,
    emitterLifetime: 0.3,
    maxParticles: 4,
    pos: {
        x: 0,
        y: 0,
    },
    addAtBack: false,
    spawnType: "point",
};

export const EMITTER_SLOT_CREATURE_STARS = {
    alpha: {
        start: 1,
        end: 1,
    },
    scale: {
        start: 0.7,
        end: 0,
        minimumScaleMultiplier: 1,
    },
    color: {
        start: "#db7f7f",
        end: "#e39494",
    },
    speed: {
        start: 200,
        end: 0,
        minimumSpeedMultiplier: 1,
    },
    acceleration: {
        x: 0,
        y: 0,
    },
    maxSpeed: 0,
    startRotation: {
        min: 0,
        max: 360,
    },
    noRotation: false,
    rotationSpeed: {
        min: 50,
        max: 100,
    },
    lifetime: {
        min: 0.4,
        max: 0.6,
    },
    blendMode: "normal",
    frequency: 0.001,
    emitterLifetime: 0.3,
    maxParticles: 4,
    pos: {
        x: 0,
        y: 0,
    },
    addAtBack: false,
    spawnType: "circle",
    spawnCircle: {
        x: 0,
        y: 0,
        r: 0,
    },
};
